import { useEffect, useState } from 'react';
import UserPool from '../../UserPool';
import { insertLog } from '../Logs/InsertLog';
import { useCustomContext } from '../CustomComponents/CustomComponents';

const ProfileLogic = () => {
    const username = localStorage.getItem('employeeName');
    const [isLoading, setLoading] = useState(false);
    const [name, setName] = useState(username);
    const { showAlert, stopHudRotation, showToast, hud } = useCustomContext();


    const email = localStorage.getItem('email');
    const userName = email?.split('@')[0];

    const handleNameChange = (event) => {
        setName(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true); // Show loading indicator

        const currentName = localStorage.getItem('employeeName');
        const isEmployeeActive = localStorage.getItem('isEmployeeActive');
        const isEmployeeApproved = localStorage.getItem('isEmployeeApproved');
        const accessLevel = parseInt(localStorage.getItem('accessLevel'), 10);

        if (!name || name.trim() === '') {
            showAlert('Name cannot be empty', [{ label: 'OK', onClick: () => { }, color: 'var(--buttonColor)' }]);
            setLoading(false);
            return;
        }

        if (name === currentName) {
            showAlert('Name cannot be the same', [{ label: 'OK', onClick: () => { }, color: 'var(--buttonColor)' }]);
            setLoading(false);
            return;
        }

        const cognitoUser = UserPool.getCurrentUser();

        if (!cognitoUser) {
            showToast({ message: "User not found. Please log in again." });
            setLoading(false);
            stopHudRotation();
            return;
        }

        const updateUserAttributes = () => {
            const updatedAttributes = [
                {
                    Name: 'custom:empInfo',
                    Value: JSON.stringify({
                        name,
                        accessLevel,
                        isEmployeeApproved,
                        isEmployeeActive
                    })
                }
            ];

            cognitoUser.updateAttributes(updatedAttributes, (err, result) => {
                setLoading(false);
                stopHudRotation();

                if (err) {
                    showToast({ message: `Error updating profile: ${err.message}`, type: 'warning' });
                    return;
                }

                localStorage.setItem('employeeName', name);
                showToast({ message: "Profile Name Updated Successfully!" });
                 insertLog(
                    `${userName} updated their profile name to ${name}`,
                    0,
                    email,
                    hud,
                    stopHudRotation,
                    showAlert
                );
            });
        };

        cognitoUser.getSession((err, session) => {
            if (err || !session.isValid()) {
                showToast({ message: "Session expired. Please log in again." });
                setLoading(false);
                stopHudRotation();
                return;
            }

            updateUserAttributes();
        });
    };

  return (
    
    {isLoading,handleNameChange,handleSubmit,hud,username,email,name}
  )
}

export default ProfileLogic